import {
    signInWithEmailAndPassword,
    signOut,
    sendPasswordResetEmail,
    UserCredential,
    AuthError,
    createUserWithEmailAndPassword
} from 'firebase/auth';
import { auth } from './firebase';

export const logIn = async (email: string, password: string): Promise<UserCredential> => {
    return signInWithEmailAndPassword(auth, email, password).then((res) => {
        return res;
    });
};

export const forgotPassword = async (email: string): Promise<void | AuthError> => {
    return sendPasswordResetEmail(auth, email).catch((error) => {
        return error as AuthError;
    });
};

export const register = async (email: string, password: string): Promise<UserCredential> => {
    return createUserWithEmailAndPassword(auth, email, password).then((res) => {
        return res;
    });
};

export const logOut = async (): Promise<void> => {
    return signOut(auth);
};
